import React, { useState } from "react";
import HelpButton from "../../HelpContent/HelpButton";
import { Accordion, Col, Nav, Row, Tab } from "react-bootstrap";
import MyBadge from "../MyBadge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faLocationPin,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import ArrowRightIcon from "../../../assets/icons/arrow_right-01.svg2";
import BoomLogicIcon from "../../../assets/icons/boom_calendar-01.svg2";
import TickIcon from "../../../assets/icons/tick.svg2";
import MyPagination from "../MyPagination";
import { DropdownButton } from "./ImportOptions";
import WorkScheduleIcon from "../../../assets/icons/cal_basic-01.svg2";
import SearchIcon from "../../../assets/icons/search.svg2";

const tabs = [
  {
    name: "workSchedule",
    heading: "Work Schedule",
    events: "300",
  },
  {
    name: "default",
    heading: "Default",
    events: "30",
  },
];
export default function CalendarMapping() {
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  return (
    <div>
      <Row className="mb-3 mt-4 p-3 align-items-center pe-5">
        <Col className="p-3"xs={12} lg={6} >
          <div className="ms-2">
            <span className="fs-4 fw-bold ">
              Mapping your fields to system fields
            </span>
            <span className="text-secondary ms-2">
              <HelpButton />
            </span>
          </div>
          <div className="text-secondary ms-2">
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </div>
        </Col>
      

        <Col xs={12} lg={6}className="d-flex justify-content-end p-3 ">
          <div className="position-relative">
            <input
              placeholder="Search..."
              className="form-control"
              style={{ height: 38, paddingRight: 40, minWidth: 100 }}
              type="text"
            />
            <SearchIcon
              width={30}
              heigth={30}
              className="white bg-colored position-absolute top-50 end-0 translate-middle rounded-circle p-2"
              style={{ marginRight: -10 }}
            />
          </div>
        </Col>
      </Row>

      <div className=" align-items-center rounded-3 py-4 mt-4 ps-4 pe-5  m-3 ">
        <Tab.Container
          id="calendar-found-tabs"
          activeKey={selectedTab.name}
          onSelect={(tab) => setSelectedTab(tabs.find((t) => t.name === tab))}
        >
          <Nav
            variant="tabs"
            className="align-items-center justify-content-center"
          >
            {tabs.map((t) => (
              <Nav.Item className="bg-transparent">
                <Nav.Link eventKey={t.name} className="fw-bold bg-transparent">
                  <div className=" ms-2">
                    <MyBadge count={t.events + " EVENTS"} />
                  </div>
                  <div className="text-black fw-bold fs-5  ms-4 mt-2 ">
                    {t.heading}
                  </div>
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          <Row className="mb-3 mt-4 p-3 align-items-end">
            <Col xs={12} lg={5}>
              <div className="ms-2 py-2">
                <span className="fs-4 fw-bold ">Import / Map Calendar:</span>
                <span className="text-secondary ms-2">
                  <HelpButton />
                </span>
              </div>
            </Col>
            <Col lg={2}></Col>

            <Col xs={12} lg={5}>
              <div className="ms-2 py-2">
                <span className="fs-4 fw-bold ">
                  System calendar to import to:
                </span>
                <span className="text-secondary ms-2">
                  <HelpButton />
                </span>
              </div>
            </Col>
          </Row>

          <Row className="mb-5 mt-4">
            <Col xs={12} lg={5}>
              <div className="bg-white rounded-4 px-4 py-2 ">
                <DropdownButton
                  option={{
                    name: "workSchedule",
                    heading: "Work Schedule",
                    subheading: (
                      <>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        <div className="d-flex py-2">
                          <span>
                            <WorkScheduleIcon width={15} className="me-2" />
                          </span>
                          <span>300 Events to import</span>
                        </div>
                      </>
                    ),
                    icon: WorkScheduleIcon,
                  }}
                />
              </div>
            </Col>
            <Col xs={12} lg={2}>
              <div className="d-flex justify-content-center ">
                <ArrowRightIcon
                  width={60}
                  height={83}
                  className="me-2 m-2 opacity-50"
                />
              </div>
            </Col>
            <Col xs={12} lg={5}>
              <Accordion>
                <Accordion.Item
                  eventKey="0"
                  className=" p-2 rounded-4 overflow-hidden"
                >
                  <Accordion.Header>
                    <div className="row flex-grow-1">
                      <div className="col-2 p-1 text-center fw-bold">
                        <BoomLogicIcon width={40} />
                      </div>
                      <div className="col-10">
                        <h5 className="fw-bold">boomLogic Calendar One</h5>
                        <h6 className="small opacity-50 ">
                          Lorem ipsum dolor sit amet consectetur...
                        </h6>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="bg-white mt-3 ">
                      <div>
                        <span className="d-flex align-items-center">
                          <TickIcon width={15} />
                          <h5 className=" p-1 small">location</h5>
                        </span>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>

          <hr className="opacity-50" />
          <div className="col-12 col-lg">
            <div className="ms-2 py-3">
              <span className="fs-4 fw-bold ">
                Or select individual events to import:
              </span>
            </div>{" "}
          </div>

          <Tab.Content>
            <Tab.Pane eventKey="workSchedule">
              <Row className="mb-5 mt-4 p-3 align-items-center">
                <Col
                  xs={12}
                  lg={5}
                  className="bg-purple-gradient-darker-reverse p-3  rounded-3"
                >
                  <div
                    className="overflow-auto d-flex flex-column p-3"
                    style={{
                      maxHeight: 300,
                      scrollbarColor:
                        "var(--color-dark-purple) rgba(var(--color-blue),0.1)",
                    }}
                  >
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item
                        eventKey="0"
                        className="rounded-4 overflow-hidden mb-3 "
                      >
                        <Accordion.Header>
                          <div className="row flex-grow-1">
                            <div className="col-2 p-1 text-center fw-bold text-purple">
                              <div className="bg-purple-gradient rounded-top-3 fs-3 ">
                                8
                              </div>
                              <div className="bg-dark-purple  text-white rounded-bottom-3 ">
                                Apr
                              </div>
                            </div>
                            <div className="col-10">
                              <h5 className="fw-bold">Engineer Appointment</h5>
                              <h6 className="small opacity-50 ">
                                Lorem ipsum dolor sit amet consectetur...
                              </h6>
                              <div className="d-flex ">
                                <span className="mt-2 me-2">
                                  <FontAwesomeIcon
                                    icon={faLocationPin}
                                    className="me-2"
                                  />
                                  Location:
                                  <span className=" opacity-50 ">
                                    London,UK
                                  </span>
                                </span>
                                <span className="mt-2 me-2">
                                  <FontAwesomeIcon
                                    icon={faUser}
                                    className="me-2"
                                  />
                                  Contacts:
                                  <span className=" opacity-50 ">25</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="bg-white mt-3 ">
                            <div>
                              <span className="d-flex align-items-center">
                                <TickIcon width={15} />
                                <h5 className=" p-1 small">location</h5>
                              </span>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item
                        eventKey="1"
                        className="rounded-4 overflow-hidden mb-3"
                      >
                        <Accordion.Header>
                          <div className="row flex-grow-1 ">
                            <div className="col-2 p-1 text-center fw-bold text-purple">
                              <div className="bg-purple-gradient rounded-top-3 fs-3 ">
                                24
                              </div>
                              <div className="bg-dark-purple  text-white rounded-bottom-3  ">
                                May
                              </div>
                            </div>
                            <div className="col-10">
                              <h5 className="fw-bold">Town Hall Meeting</h5>
                              <h6 className="small opacity-50">
                                Lorem ipsum dolor sit amet consectetur
                                adipisicing elit. Inventore ratione cupiditate
                                hic asperiores illum dignissimos reprehenderit
                                quidem dolore amet! Facere
                              </h6>
                              <div className="d-flex ">
                                <span className="mt-2 me-2">
                                  <FontAwesomeIcon
                                    icon={faClock}
                                    className="me-2"
                                  />
                                  Time:
                                  <span className=" opacity-50 ">
                                    10.30am-12.30pm
                                  </span>
                                </span>
                              </div>
                              <div className="d-flex ">
                                <span className="mt-2 me-2">
                                  <FontAwesomeIcon
                                    icon={faLocationPin}
                                    className="me-2"
                                  />
                                  Location:
                                  <span className=" opacity-50 ">
                                    London,UK
                                  </span>
                                </span>
                                <span className="mt-2 me-2">
                                  <FontAwesomeIcon
                                    icon={faUser}
                                    className="me-2"
                                  />
                                  Contacts:
                                  <span className=" opacity-50 ">25</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="bg-white rounded-3 mt-3">
                            Town hall meeting
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item
                        eventKey="2"
                        className=" mb-3 rounded-4 overflow-hidden"
                      >
                        <Accordion.Header>
                          <div className="row flex-grow-1 ">
                            <div className="col-2 p-1 text-center fw-bold text-purple">
                              <div className="bg-purple-gradient rounded-top-3 fs-3 ">
                                28
                              </div>
                              <div className="bg-dark-purple  text-white rounded-bottom-3  ">
                                May
                              </div>
                            </div>
                            <div className="col-10">
                              <h5 className="fw-bold">Team Meeting</h5>
                              <h6 className="small opacity-50 ">
                                Lorem ipsum dolor sit amet consectetur...
                              </h6>
                              <div className="d-flex ">
                                <span className="mt-2 me-2">
                                  <FontAwesomeIcon
                                    icon={faLocationPin}
                                    className="me-2"
                                  />
                                  Location:
                                  <span className=" opacity-50 ">Jaywick</span>
                                </span>
                                <span className="mt-2 me-2">
                                  <FontAwesomeIcon
                                    icon={faUser}
                                    className="me-2"
                                  />
                                  Contacts:
                                  <span className=" opacity-50 ">2</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="bg-white rounded-3 mt-3 ">
                            <div>
                              <span className="d-flex align-items-center">
                                <TickIcon width={15} />
                                <h5 className=" p-1 small">location</h5>
                              </span>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                </Col>

                <Col xs={12} lg={2}>
                  <div className="d-flex justify-content-center ">
                    <ArrowRightIcon
                      width={60}
                      className="me-2 m-2 opacity-50"
                    />
                  </div>
                </Col>
                <Col xs={12} lg={5}>
                  <div className="">
                    <span className="fw-bold">
                      <MyBadge count={2} />
                    </span>
                    <span className="fw-bold ms-2 fs-4">Events selected </span>
                  </div>
                  <div className="ms-2 py-3">
                    <span className="fs-4 fw-bold ">
                      System calendar to import events to:
                    </span>
                    <span className="text-secondary ms-2">
                      <HelpButton />
                    </span>
                  </div>

                  <Accordion>
                    <Accordion.Item
                      eventKey="0"
                      className="mb-3 rounded-4 overflow-hidden p-2"
                    >
                      <Accordion.Header>
                        <div className="row flex-grow-1">
                          <div className="col-2 p-1 text-center fw-bold">
                            <BoomLogicIcon width={40} />
                          </div>
                          <div className="col-10">
                            <h5 className="fw-bold">boomLogic Calendar One</h5>
                            <h6 className="small opacity-50 ">
                              Lorem ipsum dolor sit amet consectetur...
                            </h6>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="bg-white mt-3 ">
                          <div>
                            <span className="d-flex align-items-center">
                              <TickIcon width={15} />
                              <h5 className=" p-1 small">location</h5>
                            </span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Col>
              </Row>
            </Tab.Pane>
            <Tab.Pane eventKey="default">default</Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      <div className="ms-4 px-3">
        <MyPagination total={50} onPaginate={() => {}} />
      </div>
      <hr className="mt-3 text-secondary" />
    </div>
  );
}
